import axiosInstance from "./authentication/axiosInstance";

export const teamServices = {

    postTeamData: async (newPost) => {
        const response = await axiosInstance.post("/teams", newPost);
        return response.data;
    },

    updateTeamData: async (updatePost) => {
        const response = await axiosInstance.put("/teams", updatePost);
        return response.data;
    },

    getAllTeams: async (search, page, size, sortField = 'id', sortDir = 'desc') => {
        const response = await axiosInstance.get(`/teams?search=${search || ''}&pageNo=${page}&size=${size}&sortField=${sortField}&sortDir=${sortDir}`);
        return response.data;
    },

    deleteTeamData: async (teamId) => {
        const response = await axiosInstance.delete(`/teams/${teamId}`);
        return response.data;
    },

    getAllTeamsListForUserScreen: async () => {
        const response = await axiosInstance.get("/teams/allTeams");
        return response.data;
    },

    addMemberUserToTeam: async (formData) => {
        const response = await axiosInstance.post("/teams/addTeamMember", formData);
        return response.data;
    },

    getAllOwnerIdsList: async () => {
        const response = await axiosInstance.get("/teams/teamOwnerList");
        return response.data;
    },
};
